<template>
  <div
    aria-live="assertive"
    class="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6"
  >
    <div
      class="flex w-full flex-col items-center flex flex-col gap-4 sm:items-end"
    >
      <TransitionGroup
        enter-active-class="transform ease-out duration-300 transition"
        enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
        enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
        leave-active-class="transition ease-in duration-100"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div
          v-for="notification in notifications"
          :key="notification.id"
          class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black/5"
        >
          <div class="p-4">
            <div class="flex items-start">
              <div class="shrink-0">
                <ExclamationTriangleIcon
                  v-if="notification.icon === NotificationIconEnum.Warning"
                  class="h-6 w-6 text-red-400"
                  aria-hidden="true"
                />
                <ClipboardIcon
                  v-if="notification.icon === NotificationIconEnum.Clipboard"
                  class="h-6 w-6"
                  aria-hidden="true"
                />
              </div>
              <div class="ml-3 w-0 flex-1 pt-0.5">
                <p class="text-sm font-medium text-gray-900">
                  {{ notification.title }}
                </p>
                <p v-if="notification.text" class="mt-1 text-sm text-gray-500">
                  {{ notification.text }}
                </p>
              </div>
              <div class="ml-4 flex shrink-0">
                <button
                  type="button"
                  class="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-hidden focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                  @click="onClose(notification.id)"
                >
                  <span class="sr-only">Close</span>
                  <XMarkIcon class="h-5 w-5" aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </TransitionGroup>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import {
  NotificationIconEnum,
  useNotificationStore,
} from '~~/store/notifications'
import {
  ExclamationTriangleIcon,
  XMarkIcon,
  ClipboardIcon,
} from '@heroicons/vue/24/outline'

const notificationStore = useNotificationStore()
const { notifications } = storeToRefs(notificationStore)
const onClose = (id: string) => {
  notificationStore.removeNotification(id)
}
</script>
